import React, { useState } from 'react'
import { Link } from "react-router-dom"
import checkout_img from "../Data/sample_images/bmw_x6_1_new.png"
import { FaCcVisa, FaCcMastercard, FaPaypal, FaCcApplePay, FaGooglePay } from "react-icons/fa"
import { SiAmericanexpress } from "react-icons/si"

const Checkout = () => {

  // state to store booking Information radio choice
  const [bookingChoice, setBookingChoice] = useState("")
    
  // function to stop PHP form submission
  const handleForm = (event) => {
    event.preventDefault()
  }

  return (
    <>
        <section className='checkout'>
            <div className="container checkout-container">
                <h3 className="section-subtitle">AutoInsure</h3>
                <h1 className="section-title">Checkout</h1>
                <div className="checkout-form">
                    <div className="checkout-form-left">
                        <h2 className="checkout-car-subtitle">AutoInsure</h2>
                        <h1 className="checkout-car-title">BMW 330E 2018</h1>
                        <div className="checkout-img-container">
                            <img src={checkout_img} alt="Checkout_car" />
                        </div>
                        <div className="company-tag">
                            <div className="line"></div>
                            <span className='company-logo checkout-logo'>Auto<span className='yellow'>Insure</span></span>
                        </div>
                        <div className="booking-info-container">
                            <h2 className="booking-info-title">Booking Information</h2>
                            <form onSubmit={handleForm} className='delivery-form'>
                                <input type="radio" id="choosePickup" name="chooseBooking" className='choose-pickup' checked="true" onChange={() => setBookingChoice("pickup")}/>
                                <label for="choosePickup">Pick Up</label>
                                <span className="delivery-price">$999.89</span>
                                <p className="delivery-info">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi, sunt!</p>
                                <input type="radio" id="chooseDropoff" name="chooseBooking" className='choose-dropoff' onChange={() => setBookingChoice("dropoff")}/>
                                <label for="chooseDropoff">Drop Off</label>
                                <span className="delivery-price">$1049.89</span>
                                <p className="delivery-info">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi, sunt!</p>
                            </form>
                        </div>
                    </div>
                    <div className="checkout-divide"></div>
                    <div className="checkout-form-right">
                        <div className="booking-details-container">
                            <h2 className='booking-details-title'>Booking & Billing Details</h2>
                            <form onSubmit={handleForm} className='booking-details-form'>
                                <div className="checkout-form-group">
                                    <input type="text" id='name' placeholder='Full Name'/>
                                </div>
                                <div className="checkout-form-group">
                                    <input type="text" id='address-one' placeholder='Address'/>
                                </div>
                                <div className="checkout-form-group">
                                    <input type="text" id='address-two' placeholder='Address'/>
                                </div>
                                <div className="checkout-form-group">
                                    <input type="text" id='Post Code' placeholder='Postal Code'/>
                                </div>
                                <div className="checkout-form-group">
                                    <input type="date" id='address-one'/>
                                </div>
                            </form>
                        </div>
                        <div className="line"></div>
                        <div className="payment-details-container">
                            <h2 className="payment-details-title">Debit Card Information</h2>
                            <form onSubmit={handleForm} className='payment-details-form'>
                                <div className="checkout-form-group">
                                    <h5 className="accepted-cards">Accepted Cards:</h5>
                                    <span className="payment-method-icon"><FaCcVisa/></span>
                                    <span className="payment-method-icon"><FaCcMastercard/></span>
                                    <span className="payment-method-icon"><SiAmericanexpress/></span>
                                    <span className="payment-method-icon"><FaCcApplePay/></span>
                                    <span className="payment-method-icon"><FaGooglePay/></span>
                                    <span className="payment-method-icon"><FaPaypal/></span>
                                </div>
                                <div className="checkout-form-group">
                                    <input type="text" id='card-name' placeholder='Name on Debit Card'/>
                                </div>
                                <div className="checkout-form-group">
                                    <input type="text" id='account-number' placeholder='Account Number'/>
                                </div>
                                <div className="checkout-form-group">
                                    <input type="text" id='sort-code' placeholder='Sort Code'/>
                                </div>
                                <div className="checkout-form-group">
                                    <input type="text" id='expiry-date' placeholder='MM/YY'/>
                                </div>
                                <div className="checkout-form-group">
                                    <input type="number" id='cvv' placeholder='CVV'/>
                                </div>
                                <Link to="">
                                    <span className="cvv-info">Where is my CVV?</span>
                                </Link>
                                <button className="btn btn-lg btn-light reserve-car">Reserve Car</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Checkout
